import { EffectiveServicePriceModel, ServiceLocationModel } from "../../../entities";
import { BaseDataRepository } from "../../BaseDataRepository";
export class ServiceLocationRepo extends BaseDataRepository<ServiceLocationModel> {
  protected baseUrl = 'servicelocation';

  async addServiceToLocation(locationId: number, serviceTypeId: number): Promise<boolean> {
    const response = await this.client.post(`${this.baseUrl}/addallservicestolocation/${locationId}`, serviceTypeId);
    return this.handleResponse<boolean>(response)!;
  }

  async getByServiceAndLocationAsync(serviceId: number, locationId: number | string): Promise<ServiceLocationModel[]> {
    const response = await this.client.get(`${this.baseUrl}/GetByServiceAndLocation?serviceId=${serviceId}&locationId=${locationId}`);
    return this.handleResponse<ServiceLocationModel[]>(response)!;
  }

  async getEffectiveServicePriceAsync(serviceId: number, locationId: number): Promise<EffectiveServicePriceModel>{
    const response = await this.client.get(`${this.baseUrl}/GetEffectiveServicePrice/service/${serviceId}/location/${locationId}`)
    return this.handleResponse<EffectiveServicePriceModel>(response)!
  }

}

export default ServiceLocationRepo;
